import React from 'react';
import { FormattedMessage } from 'react-intl';

import css from './SizeModalTabs.css';

const Snowboard = ({ intl }) => {
  return (
    <div className={css.sections}>
      <div className={css.wrapper}>
        <p className={css.content} dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'SizesModal.SnowboardTab.1sectionContent' }) }} />
        <div className={css.tableWrapper}>
          <table className={css.table}>
            <thead>
              <tr>
                <th><FormattedMessage id="SizesModal.SnowboardTab.weight" /></th>
                <th><FormattedMessage id="SizesModal.SnowboardTab.height" /></th>
                <th><FormattedMessage id="SizesModal.SnowboardTab.size" /></th>
              </tr>
            </thead>
            <tbody>
              <tr><td>40 - 50</td><td>145 - 155</td><td>130 - 140</td></tr>
              <tr><td>50 - 60</td><td>155 - 165</td><td>140 - 150</td></tr>
              <tr><td>60 - 70</td><td>165 - 175</td><td>150 - 160</td></tr>
              <tr><td>70 - 80</td><td>175 - 185</td><td>155 - 165</td></tr>
              <tr><td>80 - 90</td><td>185 - 195</td><td>160 - 170</td></tr>
              <tr><td>90 - 100+</td><td>195+</td><td>165+</td></tr>
            </tbody>
          </table>
        </div>
      </div>
      <div>
        <p className={css.content}>
          <FormattedMessage id="SizesModal.SnowboardTab.2sectionContentA" />
        </p>
      </div>
    </div>
  )
}

export default Snowboard;